const computeAverage = (arr) => {
    if (!arr || !arr.length) return 0;
    const sum = arr.reduce((a, b) => a + b);
    return sum / arr.length;
};

export default computeAverage;